import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1becfc83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "intention-list" }

import PageSearch from '@/components/page-search/src/page-search.vue'
import PageContent from '@/components/page-content'
import { usePageSearch } from '@/hooks/use-page-search'
import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const [pageContentRef, handleResetClick, handleQueryClick] = usePageSearch()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageSearch, {
      "search-form-config": _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onQueryBtnClick: _unref(handleQueryClick)
    }, null, 8, ["search-form-config", "onResetBtnClick", "onQueryBtnClick"]),
    _createVNode(_unref(PageContent), {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "intention",
      pageUrl: "/pc/intention/getList"
    }, null, 8, ["contentTableConfig"])
  ]))
}
}

})